import type { NoteItemData } from './types';

export const DRAWER_BODY_STYLES: React.CSSProperties = {
  padding: 0,
};

export const CLOSE_ICON_STYLES: React.CSSProperties = {
  color: '#999999',
};

// TODO: 測試用資料，記得刪除
export const noteList: NoteItemData[] = [
  {
    id: '1',
    author: '王管理員',
    createdTime: 1703664000000,
    content: '請確認活動內容是否符合安全規範',
  },
  {
    id: '2',
    author: '李規劃師',
    createdTime: 1703667600000,
    content: '已修改活動內容，增加安全提醒事項',
  },
  {
    id: '3',
    author: '張審核員',
    createdTime: 1703671200000,
    content: '活動內容已審核通過',
  },
  {
    id: '4',
    author: '陳講師',
    createdTime: 1703674800000,
    content: '收到，將依照規範執行活動',
  },
  {
    id: '5',
    author: '林協調員',
    createdTime: 1703678400000,
    content: '場地布置已完成確認',
  },
  {
    id: '6',
    author: '黃助理',
    createdTime: 1703682000000,
    content: '器材設備檢查完畢',
  },
  {
    id: '7',
    author: '吳經理',
    createdTime: 1703685600000,
    content: '預算審核已完成',
  },
  {
    id: '8',
    author: '趙組長',
    createdTime: 1703689200000,
    content: '人力配置表已更新',
  },
  {
    id: '9',
    author: '周專員',
    createdTime: 1703692800000,
    content: '保險事宜已辦理完成',
  },
  {
    id: '10',
    author: '許主任',
    createdTime: 1703696400000,
    content: '緊急應變計畫已核定',
  },
];
